module.exports = __webpack_public_path__ + "img/frame-test-xl.ec3116e8.png";